import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-entry.ts
const optionalTrimmedStringSchema = z$1.preprocess((value) => {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : void 0;
}, z$1.string().min(1).optional());
const spaceEntryTargetSchema = z$1.strictObject({
	spaceId: nonEmptyTrimmedStringFromUnknown,
	signalId: optionalTrimmedStringSchema,
	threadRootSignalId: optionalTrimmedStringSchema
});
const getSpaceEntryResolutionInputSchema = spaceEntryTargetSchema;
const spaceEntryAllowedViewSchema = z$1.strictObject({
	state: z$1.literal("allowed"),
	experience: z$1.enum([
		"member",
		"public",
		"guest"
	])
});
const spaceEntryBlockedViewSchema = z$1.discriminatedUnion("state", [
	z$1.strictObject({ state: z$1.literal("sign_in_required") }),
	z$1.strictObject({ state: z$1.literal("password_required") }),
	z$1.strictObject({ state: z$1.literal("membership_required") }),
	z$1.strictObject({ state: z$1.literal("unavailable") })
]);
const spaceEntryViewSchema = z$1.union([spaceEntryAllowedViewSchema, spaceEntryBlockedViewSchema]);
const spaceEntryParticipationSchema = z$1.discriminatedUnion("state", [
	z$1.strictObject({ state: z$1.literal("active_member") }),
	z$1.strictObject({ state: z$1.literal("self_join_available") }),
	z$1.strictObject({ state: z$1.literal("password_required") }),
	z$1.strictObject({ state: z$1.literal("owner_add_required") }),
	z$1.strictObject({ state: z$1.literal("unavailable") })
]);
const spaceEntryOwnerSchema = z$1.strictObject({
	profileId: openMeldRuntimeProfileIdSchema,
	displayName: optionalTrimmedStringSchema
});
const spaceEntrySafeContextSchema = z$1.strictObject({
	organizationId: optionalTrimmedStringSchema,
	organizationSlug: optionalTrimmedStringSchema,
	spaceName: optionalTrimmedStringSchema,
	owner: spaceEntryOwnerSchema.optional()
});
const spaceEntryRecoverySchema = z$1.union([
	z$1.strictObject({ kind: z$1.literal("sign_in") }),
	z$1.strictObject({ kind: z$1.literal("provide_password") }),
	z$1.strictObject({ kind: z$1.literal("contact_space_owner") })
]);
const getSpaceEntryResolutionResponseSchema = z$1.strictObject({
	target: spaceEntryTargetSchema,
	view: spaceEntryViewSchema,
	participation: spaceEntryParticipationSchema,
	safeContext: spaceEntrySafeContextSchema,
	recovery: spaceEntryRecoverySchema.nullable()
});
//#endregion
export { getSpaceEntryResolutionInputSchema, getSpaceEntryResolutionResponseSchema, spaceEntryAllowedViewSchema, spaceEntryBlockedViewSchema, spaceEntryOwnerSchema, spaceEntryParticipationSchema, spaceEntryRecoverySchema, spaceEntrySafeContextSchema, spaceEntryTargetSchema, spaceEntryViewSchema };

//# sourceMappingURL=space-entry.js.map